import React from "react";
import "./LegalFooter.css";
import logoLegal from "../assets/blanco_cursos_inteligencia_artificial_educacion_eduialogic.png";

const LegalFooter = () => {
  return (
    <div className="legal-footer">
      <img src={logoLegal} alt="Logo EduIALogic" className="legal-logo" />

      <div className="legal-links">
        <div className="legal-item">
          <p>🛡️ <strong>Aviso Legal</strong></p>
          <a
            className="legal-button"
            href="https://gamma.app/docs/Aviso-Legal-p1kt44845420p2b?mode=doc"
            target="_blank"
            rel="noopener noreferrer"
          >
            Haz clic aquí
          </a>
        </div>
        <div className="legal-item">
          <p>🔐 <strong>Política de Privacidad</strong></p>
          <a
            className="legal-button"
            href="https://gamma.app/docs/Politica-de-Privacidad-fahles7foihk7sz?mode=doc"
            target="_blank"
            rel="noopener noreferrer"
          >
            Haz clic aquí
          </a>
        </div>
        <div className="legal-item">
          <p>🍪 <strong>Política de Cookies</strong></p>
          <a
            className="legal-button"
            href="https://gamma.app/docs/Politica-de-Cookies-cdgqjpw3btx4dtb?mode=doc"
            target="_blank"
            rel="noopener noreferrer"
          >
            Haz clic aquí
          </a>
        </div>
        <div className="legal-item">
          <p>📜 <strong>Términos y Condiciones</strong></p>
          <a
            className="legal-button"
            href="https://gamma.app/docs/Terminos-y-condiciones-ebxw6u5dmbly8yn?mode=doc"
            target="_blank"
            rel="noopener noreferrer"
          >
            Haz clic aquí
          </a>
        </div>
      </div>

      <p className="marca">
        EduIALogic: Ingeniería Pedagógica para la Educación Digital<br />
        EduIALogic© 2025. Todos los derechos reservados.
      </p>

      <p className="marca_2">
        EduIALogic es una marca registrada que pertenece a la razón social IALOGIC S.A.S, identificada con NIT 901880202-4.<br /> 
        Todos los contenidos, desarrollos pedagógicos y recursos digitales ofrecidos bajo la marca EduIALogic son propiedad intelectual de IALOGIC S.A.S y están<br />
        protegidos conforme a la legislación colombiana vigente.
      </p>
    </div>
  );
};

export default LegalFooter;
